import { useCopies } from "shared/hooks/useCopies";
import { useRegDetail } from "shared/context/regDetail";
import Icon from "assets/icons";

export default function RegistrationElapsed() {
  const copies = useCopies();
  const regDetails = useRegDetail();

  return (
    <div className="registrationElapsed">
      <div className="registrationElapsed_icon">
        <Icon.ByeBye />
      </div>
      <div className="registrationElapsed_content">
        <h3>
          {copies.get("registration.elapsed.msg", {
            0: regDetails.displayName
          })}
        </h3>
        <span
          dangerouslySetInnerHTML={{
            __html: copies.get("registration.elapsed.support.msg", {
              0: `<a href="mailto:${regDetails.helpdeskEmail}">${regDetails.helpdeskEmail}</a>`
            })
          }}
        />
      </div>
    </div>
  );
}
